import {gsap} from "gsap"
import { test } from "./menu_script"

import LocomotiveScroll from "locomotive-scroll";

/* Locomotive scroll instance */
const locomotiveScroll = new LocomotiveScroll();

//Initialize
const second_content = $('.second_content')
const about_img = $('.about_img')
const caption = $('.main_flex h1')
const second_trigger = $('.flex_box .second_flex')
const sus_1 = $('.contract1 h4')
const sus_2 = $('.contract1 p')
const sus_image = $('.contract2')
const about_header = $('.about h5')
const about_header2 = $('.about h1')
const about_body = $('.about p')


gsap.set([sus_1,sus_2,sus_image],{
    alpha:0,
    y:40
})

gsap.set([about_header,about_header2,about_body,about_img],{
    alpha:0,
    y:40
})

$(window).on('load',function(){
    gsap.to([about_header,about_header2,about_body,about_img],{
        alpha:1,
        stagger:.1,
        y:0,
        duration:1
    })
})

$(window).scroll(function(){
    var scrollTop = $(this).scrollTop();

    if(scrollTop > about_img.offset().top){
        second_content.css({
            opacity:1,
            transform:'translateY(0)'
         })
    }

    if(scrollTop > about_img.offset().top + 200){
        caption.css({
            opacity:1,
            transform:'translateY(0)'
         })
    }

    if(scrollTop > second_trigger.offset().top-200){
        gsap.to([sus_1,sus_2,sus_image],{
            alpha:1,
            y:0,
            stagger:.2
        })
    }
   
})

test()